<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card class="py-3" :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'">
              <v-container>
                <app-headline title="กรอกเลขบัตรประจำตัวประชาชนสำหรับการดึงข้อมูลเบื้องต้น" />

                <v-row>
                  <v-col lg="6" cols="12"
                    ><v-text-field
                      v-model="citizenID"
                      outlined
                      label="เลขบัตรประจำตัวประชาชน"
                      dense
                      maxlength="13"
                      :rules="[/^\d+$/.test(citizenID) || this.$t('rulesErrorMessage.onlyDigit')]"
                      hide-details="auto"
                      class="mt-2"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="primary" @click="initialInfo" :disabled="citizenID.length !== 13">ค้นหา</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="searchMessage.message">
                  <v-col>
                    <span :class="searchMessage.color + '--text'">
                      <v-icon :color="searchMessage.color">
                        {{ searchMessage.icon }}
                      </v-icon>
                      {{ searchMessage.message }}
                    </span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card class="py-3" :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'">
              <v-container>
                <app-headline title="ข้อมูลส่วนตัว" />
                <v-divider class="mt-2"></v-divider>
                <v-form ref="oldEmpInfo" v-model="formValidate">
                  <v-row class="mt-2">
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model="form.employeeNameTha"
                        outlined
                        required
                        :rules="[rules.required]"
                        label="ชื่อ-นามสกุล *"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model="form.employeeNameEng"
                        outlined
                        required
                        :rules="[rules.required]"
                        label="ชื่อ-นามสกุล (อังกฤษ) *"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-select
                        v-model="form.employeeTypeID"
                        :items="empTypeList"
                        :item-text="'employeeTypeName' + $lang"
                        item-value="employeeTypeId"
                        label="ประเภทบุคลากร *"
                        outlined
                        required
                        :rules="[rules.required]"
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model="form.positionNameTha"
                        outlined
                        required
                        :rules="[rules.required]"
                        label="ตำแหน่ง *"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field v-model="form.execLevel" outlined label="ระดับ" dense hide-details></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model="form.organizationWorkLevel1NameTha"
                        outlined
                        required
                        :rules="[rules.required]"
                        label="คณะ / สำนัก *"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model="form.organizationWorkLevel2NameTha"
                        outlined
                        required
                        :rules="[rules.required]"
                        label="ภาควิชา *"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-menu
                        v-model="startDateDialog"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="$dateFormatByLang(form.inDate)"
                            required
                            :rules="[rules.required]"
                            label="วันที่เริ่มทำงาน *"
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details="auto"
                            dense
                            v-on="on"
                            @click:append="startDateDialog = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$lang === 'Tha' ? 'th' : 'en'"
                          v-model="form.inDate"
                          @input="startDateDialog = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-menu
                        v-model="changeDateDialog"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="$dateFormatByLang(form.outDate)"
                            required
                            :rules="[rules.required]"
                            label="วันที่เปลี่ยนสถานภาพ *"
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details="auto"
                            dense
                            v-on="on"
                            @click:append="changeDateDialog = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$lang === 'Tha' ? 'th' : 'en'"
                          v-model="form.outDate"
                          @input="changeDateDialog = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model.number="form.pension"
                        outlined
                        label="เงินบำนาญ"
                        type="number"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model.number="form.chor_Ror_Bor"
                        outlined
                        label="เงินช่วยเหลือรายได้ผู้รับเบี้ยหวัดบำนาญ (ช.ร.บ.)"
                        type="number"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-text-field
                        v-model.number="form.chor_Kor_Bor"
                        outlined
                        label="เงินช่วยค่าครองชีพผู้รับเบี้ยหวัดบำนาญ (ช.ค.บ.)"
                        type="number"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-select
                        v-model="form.workStatusID"
                        :items="retireSelectData"
                        item-text="title"
                        item-value="value"
                        label="สถานะ *"
                        outlined
                        required
                        :rules="[rules.salary]"
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col lg="6" cols="12">
                      <v-select
                        v-model="form.sexID"
                        :items="genderSelectData"
                        item-text="title"
                        item-value="value"
                        label="เพศ *"
                        outlined
                        required
                        :rules="[rules.required]"
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col class="py-0">
                      <div class="error--text" v-if="!formValidate">
                        *กรุณากรอกข้อมูลให้ครบถ้วน
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card class="py-3" :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-0'">
              <v-container>
                <app-headline :class="$vuetify.breakpoint.smAndUp ? 'px-0' : 'px-5'" title="ข้อมูลเพิ่มเติม" />
                <v-divider :class="$vuetify.breakpoint.smAndUp ? 'mx-0' : 'mx-5'" class="mt-2"></v-divider>
                <add-stepper type="Old" :oldEmpData="form" :oldValidate="formValidate"></add-stepper>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
// import DataDisplay from '@/components/reqcer/DataDisplay.vue'
import AddStepper from '@/components/reqcer/user/AddStepper.vue';

export default {
  components: {
    AddStepper
  },
  data() {
    return {
      title: 'คำขอ',
      citizenID: '',
      citizenIDCache: '',
      startDateDialog: false,
      changeDateDialog: false,
      searchMessage: {
        message: '',
        color: '',
        icon: ''
      },
      form: {
        chor_Kor_Bor: 0.0,
        chor_Ror_Bor: 0.0,
        earlyStatus: true,
        earlyStatusName: 'เกษียณ',
        employeeID: null,
        employeeNameEng: '',
        employeeNamePositionEng: null,
        employeeNamePositionTha: null,
        employeeNameTha: '',
        employeeTypeID: 0,
        employeeTypeNameEng: null,
        employeeTypeNameTha: null,
        execLevel: null,
        firstNameEng: null,
        firstNameTha: null,
        outDate: '',
        inDate: '',
        lastNameEng: null,
        lastNameTha: null,
        middleNameEng: null,
        middleNameTha: null,
        mobilePhone: null,
        organizationWorkLevel1ID: null,
        organizationWorkLevel1NameEng: '',
        organizationWorkLevel1NameTha: '',
        organizationWorkLevel2ID: null,
        organizationWorkLevel2NameEng: '',
        organizationWorkLevel2NameTha: '',
        pension: 0,
        positionExecID: 0,
        positionExecNameEng: null,
        positionExecNameTha: null,
        positionID: 0,
        positionNameEng: null,
        positionNameTha: null,
        salary: 0,
        salaryByManagementPosition: 0.0,
        salaryByManagementPosition2: 0.0,
        salaryBySpecialPosition: 0.0,
        workLineID: 2,
        workStatusID: 20,
        moneyRetireFlag: false,
        sexID: ''
      },
      formValidate: null,
      empTypeList: []
    };
  },
  computed: {
    rules() {
      return {
        required: v => !!v,
        salary: v => !!v || v === 0
      };
    },
    emptypeid() {
      return this.form.employeeTypeID;
    },
    retireSelectData() {
      return [
        {
          title: 'เกษียณอายุ',
          value: 20
        },
        {
          title: 'ลาออก',
          value: 0
        }
      ];
    },
    genderSelectData() {
      return [
        {
          title: 'หญิง',
          value: 'F'
        },
        {
          title: 'ชาย',
          value: 'M'
        }
      ];
    }
  },

  async mounted() {
    await this.getEmpTypeList();
    // console.log(this.empTypeList)
  },

  watch: {
    '$root.$i18n.locale'() {
      if (this.citizenIDCache) {
        this.initialInfo();
      }
    },
    emptypeid() {
      this.empTypeList.forEach(item => {
        if (item.employeeTypeId === this.emptypeid) {
          this.form.employeeTypeNameTha = item.employeeTypeNameTha;
          this.form.employeeTypeNameEng = item.employeeTypeNameEng;
        }
      });
    }
  },

  methods: {
    async getEmpTypeList() {
      const res = await this.apiGetEmpTypeList();
      this.empTypeList = res.data.data;
      // const lang = this.$lang
      this.empTypeList.shift();

      // console.log(res)

      // this.empTypeList =
      //   info.map(item => {
      //     return {
      //       value: item.employeeTypeId,
      //       text: item[`employeeTypeName${lang}`]
      //     }
      //   }) || []
    },
    async initialInfo() {
      this.citizenIDCache = this.citizenID;
      const res = await this.apiGetInfo();
      // console.log(res)
      if (res.status === 204) {
        this.searchMessage.message = 'ไม่พบข้อมูลของหมายเลข ' + this.citizenIDCache + ' กรุณากรอกข้อมูลด้านล่างใหม่';
        this.searchMessage.color = 'error';
        this.searchMessage.icon = 'mdi-close-circle-outline';
      } else {
        const info = res.data.data || {};

        this.searchMessage.message = 'พบข้อมูลของหมายเลข ' + this.citizenIDCache + ' - ' + info.employeeNameTha;
        this.searchMessage.color = 'success';
        this.searchMessage.icon = 'mdi-check-circle-outline';

        this.form.employeeNameTha = info.employeeNameTha;
        this.form.employeeNameEng = info.employeeNameEng;
        this.form.employeeTypeID = info.employeeTypeID;
        this.form.positionNameTha = info.positionNameTha;
        this.form.execLevel = info.execLevel;
        // this.form.salary = info.salary
        this.form.organizationWorkLevel1NameTha = info.organizationWorkLevel1NameTha;
        this.form.organizationWorkLevel2NameTha = info.organizationWorkLevel2NameTha;
        this.form.inDate = this.$dateFormat(info.inDate);
        this.form.outDate = this.$dateFormat(info.outDate);
        this.form.pension = info.pension;
        this.form.chor_Kor_Bor = info.chor_Kor_Bor;
        this.form.chor_Ror_Bor = info.chor_Ror_Bor;
        this.form.workStatusID = info.workStatusID;
        this.form.moneyRetireFlag = info.moneyRetireFlag;
        this.form.earlyStatus = info.earlyStatus;
        this.form.earlyStatusName = info.earlyStatusName;
        this.form.employeeID = info.employeeID;
        this.form.employeeNamePositionEng = info.employeeNamePositionEng;
        this.form.employeeNamePositionTha = info.employeeNamePositionTha;
        this.form.employeeTypeNameEng = info.employeeTypeNameEng;
        this.form.employeeTypeNameTha = info.employeeTypeNameTha;
        this.form.firstNameEng = info.firstNameEng;
        this.form.firstNameTha = info.firstNameTha;
        this.form.lastNameEng = info.lastNameEng;
        this.form.lastNameTha = info.lastNameTha;
        this.form.middleNameEng = info.middleNameEng;
        this.form.middleNameTha = info.middleNameTha;
        this.form.organizationWorkLevel1ID = info.organizationWorkLevel1ID;
        this.form.organizationWorkLevel1NameEng = info.organizationWorkLevel1NameEng;
        this.form.organizationWorkLevel1NameTha = info.organizationWorkLevel1NameTha;
        this.form.organizationWorkLevel2ID = info.organizationWorkLevel2ID;
        this.form.organizationWorkLevel2NameEng = info.organizationWorkLevel2NameEng;
        this.form.organizationWorkLevel2NameTha = info.organizationWorkLevel2NameTha;
        this.form.positionExecID = info.positionExecID;
        this.form.positionExecNameEng = info.positionExecNameEng;
        this.form.positionExecNameTha = info.positionExecNameTha;
        this.form.positionID = info.positionID;
        this.form.positionNameEng = info.positionNameEng;
        this.form.positionNameTha = info.positionNameTha;
        this.form.salaryByManagementPosition = info.salaryByManagementPosition;
        this.form.salaryByManagementPosition2 = info.salaryByManagementPosition2;
        this.form.salaryBySpecialPosition = info.salaryBySpecialPosition;
        this.form.workLineID = info.workLineID;
        this.form.sexID = info.sexID;
        this.form.workStatusNameTha = info.workStatusNameTha;
        this.form.workStatusNameEng = info.workStatusNameEng;
        //console.log(this.form);
      }
    },

    async apiGetInfo() {
      try {
        const res = await this.$store.dispatch('reqCer/getOldEmpBasicInfo', this.citizenIDCache);
        return res;
      } catch (e) {
        console.log(e.response || e);
      }
    },

    async apiGetEmpTypeList() {
      try {
        const res = await this.$store.dispatch('reqCer/getEmpTypeList');
        return res;
      } catch (e) {
        console.log(e.response || e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
